














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PolaSerangan extends Vue {
  @Prop() setPolaSerangan: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  // polaSerangan = null;

  // @Watch("polaSerangan")
  // changePolaSerangan(val) {
  //   this.$emit("polaSerangan", val);
  // }

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setPolaSerangan == "" || this.setPolaSerangan == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setPolaSerangan")
  valPolaSerangan(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("polaSerangan", val);
    this.setPolaSerangan = val;
  }
}
